let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("arhgZ"), load("l7dDG")]).then(() => parcelRequire('4CgFO'));